import React from 'react'
import { useTranslation } from 'react-i18next'
import { Headline } from 'components/text/Headline'
import { Box as GreetingContainer } from '@node-space/storybook-components'

interface GreetingUserProps {
  firstName: string
  className?: string
}

const GreetingUser = ({ firstName, className }: GreetingUserProps) => {
  const { t } = useTranslation()
  return (
    <GreetingContainer testid="user-greeting" className={className}>
      <div
        className="absolute right-0 top-0 -mt-4 mr-16 pointer-events-none hidden xl:block"
        aria-hidden="true"
      ></div>
      <div className="mb-1">
        <Headline>
          {t('welcomeBack')} {firstName}
        </Headline>
      </div>
    </GreetingContainer>
  )
}

export default GreetingUser
